import React, { useId } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

/* Names an icon-only control on hover and keyboard focus. The tip renders into
   document.body, so the table's scroll wrapper cannot clip it. The child must
   accept a ref (a <button> or a router <Link>) and keep its own aria-label -
   the tip is for sighted users, not the accessible name. */
const ActionTooltip = ({ label, placement = "top", children }) => {
  const id = useId();
  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show: 250, hide: 0 }}
      overlay={<Tooltip id={id}>{label}</Tooltip>}
    >
      {children}
    </OverlayTrigger>
  );
};

export default ActionTooltip;
